import { get, omit } from 'lodash';
import { all, call, put, takeEvery } from 'redux-saga/effects';

import { REDUX_STORE } from '@funnels/constants';
import { FetchCustomerMeAction, FetchCustomersAction, UpdateCustomersAction } from '@funnels/types';
import { datadogUtil } from '@funnels/utils';

import { waitForAuth } from '../_common';
import {
  fetchCustomerMeFail,
  fetchCustomerMeSuccess,
  fetchCustomersFail,
  fetchCustomersSuccess,
  setCustomerError,
  updateCustomersFail,
  updateCustomersSuccess,
} from './actions';
import CustomersAPI from './api';

export function* fetchCustomerMeWorker(action: FetchCustomerMeAction): any {
  try {
    yield waitForAuth();
    const response = yield call(CustomersAPI.fetchMe);

    yield put(fetchCustomerMeSuccess(response.data));
  } catch (e: any) {
    datadogUtil.addError(e);
    yield all([put(fetchCustomerMeFail()), put(setCustomerError(e.message))]);
  }
}

export function* fetchCustomersWorker(action: FetchCustomersAction): any {
  try {
    yield waitForAuth();
    const { customerIdList } = action;
    const customerData = [];

    for (let i = 0; i < customerIdList.length; i++) {
      const response = yield call(CustomersAPI.fetch, customerIdList[i]);
      customerData.push(response.data);
    }

    yield put(fetchCustomersSuccess(customerData));
  } catch (e: any) {
    datadogUtil.addError(e);
    yield all([put(fetchCustomersFail()), put(setCustomerError(e.message))]);
  }
}

export function* updateCustomersWorker(action: UpdateCustomersAction) {
  try {
    yield waitForAuth();
    const { customers } = action;

    yield all(
      customers.map((customer) => {
        const serverCustomer = omit(customer, [
          'id',
          'brand',
          'isDeidentified',
          'isDeleted',
          'updatedAt',
          'createdAt',
          'mobileVerified',
          'emailVerified',
        ]);
        return call(CustomersAPI.update, customer.id!, serverCustomer);
      })
    );
    yield put(updateCustomersSuccess());
  } catch (e: any) {
    // skip 404 not found error
    if (get(e, 'response.status') === 404) {
      yield put(updateCustomersSuccess());
    } else {
      datadogUtil.addError(e);
      yield all([put(updateCustomersFail()), put(setCustomerError(e.response?.data || e.message))]);
    }
  }
}

export function* customersWatcher() {
  yield takeEvery(REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMER_ME, fetchCustomerMeWorker);
  yield takeEvery(REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMERS, fetchCustomersWorker);
  yield takeEvery(REDUX_STORE.CUSTOMERS.ACTION_TYPES.UPDATE_CUSTOMERS, updateCustomersWorker);
}

export default customersWatcher;
